import { useQuery } from '@apollo/client'
import React from 'react'
import {
  VaccinationFilterInput,
  GetVaccinationForVerification,
  GetVaccinationForVerificationVariables,
} from '../../types'
import { GET_VACCINATION_FOR_VERIFICATION } from './operations'

interface Props {
  filter?: VaccinationFilterInput
  page?: number
  pageLength?: number
}

const PAGE_LENGTH = 10

export const useVaccinationForVerification = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
}: Props) => {
  const { emailOrNameLike } = filter || {}
  const queryVariables = React.useMemo<GetVaccinationForVerificationVariables>(
    () => ({
      filterData: {
        emailOrNameLike,
      },
      pagination: {
        from: pageLength * (page - 1) || 0,
        length: pageLength,
      },
    }),
    [emailOrNameLike, page, pageLength]
  )
  const vaccinations = useQuery<
    GetVaccinationForVerification,
    GetVaccinationForVerificationVariables
  >(GET_VACCINATION_FOR_VERIFICATION, {
    variables: queryVariables,
  })
  return vaccinations
}
